export default __webpack_public_path__ + "static/media/purple-planet.84cbfac5.png";